module.exports = __webpack_public_path__ + "324c50b0aa0a032c9a1708c240cdf5d4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-princess-sleep.svg
// module id = 479
// module chunks = 0